export const enum AuthIDEnum {
  ALL = 'all', // 所有
  SPACE = 'space', // 项目 cms
  BOT = 'bot', // 机器人 cms + ugc
  CARD = 'card', // 卡片 cms
  STORY = 'story', // 故事 cms + ugc
  LIST = 'list', // 列表 cms + ugc

  PROPS = 'props',
  DOCS = 'docs',


  SPACE_LIST_CMS = 'space_list_cms', // 项目列表-cms
  SPACE_LIST_UGC = 'space_list_ugc', // 项目列表-ugc

}
